module.exports = __webpack_public_path__ + "img/t5-17.8227703f.svg";